import { render, staticRenderFns } from "./SettingsModalCourse.vue?vue&type=template&id=a3a42f66&scoped=true"
import script from "./SettingsModalCourse.vue?vue&type=script&lang=js"
export * from "./SettingsModalCourse.vue?vue&type=script&lang=js"
import style0 from "./SettingsModalCourse.vue?vue&type=style&index=0&id=a3a42f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a42f66",
  null
  
)

export default component.exports